import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { t } from 'i18next'

import { useFeatureToggle } from '@/features/featureToggle/contexts/FeatureToggleContext'
import { FeatureToggleNames } from '@/features/resource/constants'

const { DISABLE_STATUS_UPDATES_BY_RESOURCE_TYPE, RES_DISABLE_BY_LOCATION, INTERNAL_RESOURCE_SYNC } = FeatureToggleNames

const renderToggleValue = (value: boolean | 'not-defined') => {
  if (value === 'not-defined') return t('resources.support_toolbox.toggle_table.not-defined_label')
  return value.toString()
}

const ResourceSupportToolboxFeatureToggleTable = ({ resource }) => {
  const { isEnabled, useFeatureWithContext } = useFeatureToggle()

  const disableStatusUpdatesByResourceTypeFeature = useFeatureWithContext(DISABLE_STATUS_UPDATES_BY_RESOURCE_TYPE, {
    resourceType: resource.resourceType,
  })

  const resDisabledByLocationFeature = useFeatureWithContext(RES_DISABLE_BY_LOCATION, {
    location: resource.siteLocation,
  })

  const isDisableStatusUpdatesByResourceType =
    resource.resourceType !== undefined ? disableStatusUpdatesByResourceTypeFeature.isFeatureEnabled : 'not-defined'

  const isResDisabledByLocation =
    resource.siteLocation !== undefined ? resDisabledByLocationFeature.isFeatureEnabled : 'not-defined'

  const isInternalResourceSyncEnabled = isEnabled(INTERNAL_RESOURCE_SYNC)

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>{t('resources.support_toolbox.toggle_table.toggle_column_label')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('resources.support_toolbox.toggle_table.value_column_label')}</strong>
            </TableCell>
            <TableCell>
              <strong>{t('resources.support_toolbox.toggle_table.context_column_label')}</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{DISABLE_STATUS_UPDATES_BY_RESOURCE_TYPE}</TableCell>
            <TableCell>{renderToggleValue(isDisableStatusUpdatesByResourceType)}</TableCell>
            <TableCell>
              {resource.resourceType ?? t('resources.support_toolbox.toggle_table.not-defined_label')}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{RES_DISABLE_BY_LOCATION}</TableCell>
            <TableCell>{renderToggleValue(isResDisabledByLocation)}</TableCell>
            <TableCell>
              {resource.siteLocation ?? t('resources.support_toolbox.toggle_table.not-defined_label')}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{INTERNAL_RESOURCE_SYNC}</TableCell>
            <TableCell>{renderToggleValue(isInternalResourceSyncEnabled)}</TableCell>
            <TableCell />
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ResourceSupportToolboxFeatureToggleTable
